import { TipViewer } from "./components/tips/TipViewer";
import { TopicConfiguration } from "./TopicConfiguration";

export const BlankDoc = ({
  selectDisabled = false
}: {
  selectDisabled?: boolean;
}) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        backgroundColor: "#FFFFFF"
      }}
    >
      {/* Top-left dropdown */}
      <div
        style={{ padding: "12px 20px", width: "100%", alignSelf: "flex-start" }}
      >
        <TopicConfiguration disabled={selectDisabled} />
      </div>

      {/* Centered content (tip + blank doc text) */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          flex: 1,
          position: "relative"
        }}
      >
        {/* Tip positioned higher */}
        <div style={{ marginTop: "15%" }}>
          <TipViewer tipId="tip_blank_document" />
        </div>

        {/* Blank Doc text centered in container */}
        <p
          style={{
            color: "#0000004D",
            fontWeight: 500,
            fontSize: 24,
            textAlign: "center",
            margin: 0,
            position: "absolute",
            top: "50%",
            transform: "translateY(-50%)"
          }}
        >
          Blank Doc
        </p>
      </div>
    </div>
  );
};
